import {Switch} from "antd";
import React from "react";
import {InputWrapper, SplitInputWrapperProps} from "../../functions";
import {SwitchInputBoxProps} from "./interface";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";
import {validations} from "../../../../config/validations/validations";

const SwitchInputBox: React.FC<SwitchInputBoxProps> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps,
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.other());
    }

    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            valuePropName="checked"
            {...formProps}
        >
            <Switch {...inputProps} />
        </InputWrapper>
    );
};

export default SwitchInputBox;
